<mat-tab-group class="tabBar" mat-stretch-tabs>
    <mat-tab label="Passwort zurücksetzen" *ngIf="this.data.type === 'passwordReset'">
        <form [formGroup]="resetPasswordForm" (submit)="onPasswordReset()">
            <mat-form-field class="example-full-width-password">
                <mat-label>Email-Adresse</mat-label>
                <input matInput type="email" formControlName="email" class="form-control" placeholder="xyz@abc.de">
            </mat-form-field>
            <br /><mat-label class="error">{{errorMessage}}</mat-label>
            <div class="center">
                <button mat-stroked-button type="submit" class="btn btn-default button">Passwort zurücksetzen</button>
            </div>
        </form>
    </mat-tab>

    <mat-tab label="Passwort ändern" *ngIf="this.data.type === 'passwordChange'">
        <form [formGroup]="changePasswordForm" (submit)="onChangePassword()" autocomplete="off">
            <mat-label>E-Mail Adresse: {{ email }}</mat-label>
            <mat-form-field class="example-full-width">
                <mat-label>Altes Passwort</mat-label>
                <input matInput type="password" formControlName="oldPassword" class="form-control" autocomplete="off">
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Neues Passwort</mat-label>
                <input matInput type="password" class="form-control" formControlName="newPassword">
            </mat-form-field>
            <br /><mat-label class="error">{{errorMessage}}</mat-label>

            <div class="center">
                <button mat-stroked-button type="submit" class="btn btn-default button">Passwort ändern</button>
            </div>
        </form>
    </mat-tab>

  <mat-tab label="Mail ändern" *ngIf="this.data.type === 'mailChange'">
    <form [formGroup]="changeMailForm" (submit)="onChangeMail()">
      <mat-form-field class="example-full-width-password">
        <mat-label>Neue Email-Adresse</mat-label>
        <input matInput type="email" formControlName="newMail" class="form-control" placeholder="xyz@abc.de">
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Passwort</mat-label>
        <input matInput type="password" class="form-control" formControlName="password">
      </mat-form-field>

      <br /><mat-label class="error">{{errorMessage}}</mat-label>
      <div class="center">
        <button mat-stroked-button type="submit" class="btn btn-default button">E-Mail ändern</button>
      </div>
    </form>
  </mat-tab>
</mat-tab-group>
